interface assetsInterface {
  apiUrl: string
  serverlessUrl: string
}

const assets: assetsInterface = {
  apiUrl: 'https://viperpay-api.herokuapp.com/api/',
  serverlessUrl: '/.netlify/functions/'
}

export default assets
